import { render, staticRenderFns } from "./page-email-push.vue?vue&type=template&id=98ab687a"
import script from "./page-email-push.vue?vue&type=script&lang=ts"
export * from "./page-email-push.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports